import { Dto, DtoWithId } from "@mango/core";


@Dto({fullName: "CIJBorculo.Logic.SoortTemperatuur"})
export class SoortTemperatuur extends DtoWithId {
	omschrijving: string;
}